module.exports = __webpack_public_path__ + "img/h-instagram.197198b7.svg";